import { FC } from 'react';
import { LlmSessionInfo } from 'src/types/llmInfo';
import {
    EmptyState,
    SessionCard,
    SessionId,
    SessionListPanel,
    SessionMeta,
    SessionType
} from '../styled';

interface Props {
    sessions: LlmSessionInfo[];
    activeSessionId: string | null;
    onSelect: (sessionId: string) => void;
}

const formatCost = (value: number): string => {
    return `$${value.toFixed(4)}`;
};

const formatCreated = (created: string | null): string => {
    if (!created) return '—';
    const d = new Date(created);
    if (Number.isNaN(d.getTime())) return created;
    return d.toLocaleString();
};

const SessionList: FC<Props> = ({ sessions, activeSessionId, onSelect }) => {
    if (sessions.length === 0) {
        return (
            <SessionListPanel>
                <EmptyState>No LLM sessions recorded yet.</EmptyState>
            </SessionListPanel>
        );
    }

    return (
        <SessionListPanel>
            {sessions.map((session, index) => {
                const id = session.sessionId ?? `unattributed-${index}`;
                const active = id === activeSessionId;
                return (
                    <SessionCard
                        key={id}
                        active={active}
                        onClick={() => onSelect(id)}
                    >
                        {session.llmSessionType && (
                            <SessionType>{session.llmSessionType}</SessionType>
                        )}
                        <SessionId>
                            {session.sessionId ?? '(no session id)'}
                        </SessionId>
                        <SessionMeta>
                            {formatCreated(session.created)} ·{' '}
                            {formatCost(session.costUsd)}
                        </SessionMeta>
                    </SessionCard>
                );
            })}
        </SessionListPanel>
    );
};

export default SessionList;
